var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('ac-simple-automation',{attrs:{"rule_json":_vm.ruleJson},model:{value:(_vm.ruleBuilderJson),callback:function ($$v) {_vm.ruleBuilderJson=$$v},expression:"ruleBuilderJson"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }